var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getClasses},[(!_vm.noHeader)?_c('h1',{domProps:{"innerHTML":_vm._s(_vm.headerText)}}):_vm._e(),_c('v-container',{staticClass:"view-wrapper__body pa-0",attrs:{"grid-list-lg":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }